export default __webpack_public_path__ + "static/media/tick.a116cdc6.svg";